import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { deleteRegistrar } from 'API/TRSRegistrar/deleteRegistrar';

const useDeleteRegistrar = (onSuccess, onError) => {
    const queryClient = useQueryClient();
    const { currentCompany } = useSelector((state) => state.navigationLists);
    const { requiredScope } = useSelector((state) => state.login);

    const deleteRegistrarMutation = async (registrarId) => {
        try {
            const response = await deleteRegistrar(registrarId, requiredScope);
            return response.data;
        } catch (error) {
            console.error('Error deleting registrar:', error);
            throw error;
        }
    };

    return useMutation({
        mutationFn: deleteRegistrarMutation,
        onSuccess: (data, registrarId) => {
            // Invalidate and refetch the registrars list
            queryClient.invalidateQueries({
                queryKey: ['Registrars', currentCompany],
            });
            queryClient.invalidateQueries({ queryKey: ['Registrars'] });
            // Remove the specific registrar from cache
            queryClient.removeQueries({ queryKey: ['Registrar', registrarId] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useDeleteRegistrar;
